<span class="brand" [class.is-light]="light" [ngClass]="'is-' + size" role="img" aria-label="Wise">
  <img class="brand__mark" src="./assets/media/logos/wise-mark.png" alt="" />
  <span class="brand__word">Wise</span>
</span>
